module.exports = __webpack_public_path__ + "img/Frame6.4bb10860.png";